import { IAnyContentfulEntry } from '@move-frontend/contentful/dist/api/types';
import { contentful } from '../../../../shared/api/contentful';
import { NEWS_ALERT_TYPE_ID } from '../../../../shared/api/contentful/constants';
import {
	INewsAlert,
	INewsAlertEntry,
	NewsAlertType,
} from '../../../../shared/api/contentful/types';
import { ILocale } from '../../../../shared/i18n/locale/models/ILocale';

const MAX_ALERTS = 3;

const VALID_TYPES: string[] = Object.values(NewsAlertType);

export function toNewsAlert(entry: INewsAlertEntry): INewsAlert | null {
	const { title, body, link, linkLabel, type } = entry.fields;

	if (!title || !body) return null;
	if (!type || !VALID_TYPES.includes(type)) return null;

	return {
		id: entry.id,
		title,
		body,
		link: link || undefined,
		linkLabel: linkLabel || undefined,
		type,
	};
}

// Alerts are resolved at build time as part of the common page data. A
// Contentful publish triggers a static rebuild (see cd.contentful-trigger.yml),
// which is what keeps them current on the exported site.
export async function getNewsAlerts(locale: ILocale): Promise<INewsAlert[]> {
	const entries = await contentful()
		.entry<INewsAlertEntry, IAnyContentfulEntry>(NEWS_ALERT_TYPE_ID)
		.get({
			locale: locale.code,
			order: '-sys.updatedAt',
			limit: MAX_ALERTS,
		});

	return entries
		.map(toNewsAlert)
		.filter((alert): alert is INewsAlert => alert !== null);
}
